export default {"src":"/_next/static/media/being-active.colour.abaa7d38.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};